import React from "react";
import { Link } from "react-router-dom";
import Icon from "./AppIcon";

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
    {
      title: "Quick Links",
      links: [
        { path: "/homepage", label: "Home" },
        { path: "/menu", label: "Menu" },
        { path: "/locations", label: "Locations" },
        { path: "/about", label: "About Us" },
      ],
    },
    {
      title: "Customer Service",
      links: [
        { path: "#", label: "Contact Us" },
        { path: "#", label: "FAQs" },
        { path: "#", label: "Delivery Info" },
        { path: "#", label: "Catering" },
      ],
    },
    {
      title: "Legal",
      links: [
        { path: "#", label: "Privacy Policy" },
        { path: "#", label: "Terms of Service" },
        { path: "#", label: "Allergen Info" },
        { path: "#", label: "Nutritional Info" },
      ],
    },
    {
      title: "Connect",
      links: [
        { path: "#", label: "Facebook" },
        { path: "#", label: "Instagram" },
        { path: "#", label: "Twitter" },
        { path: "#", label: "Youtube" },
      ],
    },
  ];

  const socialLinks = [
    { icon: "Facebook", label: "Facebook", url: "#" },
    { icon: "Instagram", label: "Instagram", url: "#" },
    { icon: "Twitter", label: "Twitter", url: "#" },
    { icon: "Youtube", label: "YouTube", url: "#" },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {footerSections?.map((section) => (
            <div key={section?.title}>
              <h3 className="footer-section-title">{section?.title}</h3>
              <div className="footer-links">
                {section?.links?.map((link) => (
                  <Link
                    key={link?.label}
                    to={link?.path}
                    className="footer-link"
                  >
                    {link?.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Taco Street Digital. All rights reserved. 100% Halal
            Certified.
          </p>

          <div className="footer-social">
            {socialLinks?.map((social) => (
              <a
                key={social?.label}
                href={social?.url}
                className="footer-social-link"
                aria-label={social?.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon name={social?.icon} size={20} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
